import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { API_URL_SERVER } from "../../api/api";
import PnLCalendar from "../PnLCalendar/PnLCalendar.js";
import { AuthContext } from "../../context/AuthContext";
import TradeDashboard from "../TradeDashboard/TradeDashboard.js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AccountsPage = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const VALID_SYMBOLS = [
    "BTCUSD",
    "XAUUSD",
    "XAUUSD.ls",
    "XAUUSD.pr",
    "XAUUSD.le",
    "EURUSD",
    "USDJPY",
    "GBPUSD",
    "USTEC",
    "USOIL",
    "BTCXAU",
    "GBPJPY",
  ];
  const [formData, setFormData] = useState({
    mt5AccountId: "",
    password: "",
    mt5Server: "",
    nickName: "",
    strategy: "Main to Copy",
    lot_size: "1.0",
    max_profit: "0",
    max_loss: "0",
    trailing_sl_offset: "10",
    symbols: ["BTCUSD"],
    show_balance: false,
    send_telegram_notifications: false,
  });
  const [copyFormData, setCopyFormData] = useState({
    mt5AccountId: "",
    password: "",
    mt5Server: "",
    nickName: "",
    strategy: "Main to Copy",
    lot_size: "1.0",
    max_profit: "0",
    max_loss: "0",
    trailing_sl_offset: "10",
    symbols: ["BTCUSD"],
    sourceAccountId: "",
    show_balance: false,
    send_telegram_notifications: false,
  });
  const [accounts, setAccounts] = useState([]);
  const [positions, setPositions] = useState([]);
  // const [accountPnL, setAccountPnL] = useState({}); // New state for live PnL
  // const [message, setMessage] = useState('');
  const [status, setStatus] = useState({ trading_active: false, accounts: {} });
  const [showPnLModal, setShowPnLModal] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState(null);
  const [showCopyForm, setShowCopyForm] = useState(false);
  const [copySourceAccount, setCopySourceAccount] = useState(null);
  const [showCombinedPnLModal, setShowCombinedPnLModal] = useState(false);
  const [combinedPnLAccountIds, setCombinedPnLAccountIds] = useState([]);
  const [showTradeDashboardModal, setShowTradeDashboardModal] = useState(false);
  const [selectedAccountDetails, setSelectedAccountDetails] = useState(null);
  const [showWithdrawalsModal, setShowWithdrawalsModal] = useState(false);
  const [showWithdrawalsViewModal, setShowWithdrawalsViewModal] =
    useState(false);
  const [selectedWithdrawalAccount, setSelectedWithdrawalAccount] =
    useState(null);
  const [withdrawalAmount, setWithdrawalAmount] = useState("");
  const [withdrawalDate, setWithdrawalDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [withdrawalNotes, setWithdrawalNotes] = useState("");
  const [withdrawals, setWithdrawals] = useState([]);
  const [totalWithdrawn, setTotalWithdrawn] = useState(0);
  
  // --- NEW STATE FOR BULK LOT UPDATE ---
  const [showLotUpdateModal, setShowLotUpdateModal] = useState(false);
  const [lotDivisor1, setLotDivisor1] = useState("");
  const [lotDivisor2, setLotDivisor2] = useState("");
  const [isUpdatingLots, setIsUpdatingLots] = useState(false);
   const [strategies, setStrategies] = useState([]);

  useEffect(() => {
    if (user) {
      fetchAccounts();
      fetchStrategies(); // Fetch strategies on component mount
      
      // Check for admin role OR specific permission OR if they possess full access accounts
      if (user.role === "admin" || user.can_start_stop === true || user.show_lot_size === true || user.can_edit_lot === true || user?.fullAccessAccountIds?.length > 0) {
        fetchStatus();
        const statusInterval = setInterval(fetchStatus, 3000);
        return () => {
          clearInterval(statusInterval);
        };
      }
    }
  }, [user]);
  console.log(user?.fullAccessAccountIds?.length > 0 ? "User has full access accounts" : "User does NOT have full access accounts");
  console.log(user);

  const fetchAccounts = async () => {
    try {
      const response = await axios.get(`${API_URL_SERVER}/accounts`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setAccounts(response.data);
      console.log("Fetched accounts:", response.data);
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to fetch accounts");
      console.error("Fetch accounts error:", error);
    }
  };

  const fetchStrategies = async () => {
    try {
      // MODIFIED: Changed the endpoint from /strategy-configs to /all-strategies
      const response = await axios.get(`${API_URL_SERVER}/all-strategies`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      // The new endpoint returns a simple array of names, so we can use it directly.
      // We ensure 'Main to Copy' is always an option.
      const allStrategies = [...new Set(['Main to Copy', ...response.data])];
      setStrategies(allStrategies);
    } catch (error) {
      console.error("Failed to fetch all strategies:", error);
      // Fallback in case of an error
      setStrategies(['Main to Copy']);
      toast.error("Failed to fetch strategies; using default.");
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await axios.get(`${API_URL_SERVER}/status`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setStatus({ ...response.data });
      console.log("Fetched status:", response.data);
    } catch (error) {
      console.error("Failed to fetch status:", error);
      setStatus({ trading_active: false, accounts: {} });
      toast.error("Failed to fetch status; assuming trading stopped");
    }
  };

  const fetchWithdrawals = async (accountId) => {
    try {
      const response = await axios.get(
        `${API_URL_SERVER}/withdrawals/${accountId}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      setWithdrawals(response.data.withdrawals);
      setTotalWithdrawn(response.data.total_withdrawn);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to fetch withdrawals"
      );
      setWithdrawals([]);
      setTotalWithdrawn(0);
    }
  };

  const handleAddWithdrawal = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Please log in to add withdrawal");
        return;
      }

      if (
        !withdrawalAmount ||
        isNaN(withdrawalAmount) ||
        parseFloat(withdrawalAmount) <= 0
      ) {
        toast.error("Please enter a valid positive amount");
        return;
      }

      const payload = {
        account_id: selectedWithdrawalAccount,
        amount: parseFloat(withdrawalAmount),
        date: withdrawalDate,
        notes: withdrawalNotes,
      };

      await axios.post(`${API_URL_SERVER}/withdrawals`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await fetchWithdrawals(selectedWithdrawalAccount);

      setWithdrawalAmount("");
      setWithdrawalDate(new Date().toISOString().split("T")[0]);
      setWithdrawalNotes("");
      toast.success("Withdrawal added successfully");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error adding withdrawal");
    }
  };
  const handleShowWithdrawals = (accountId) => {
    setSelectedWithdrawalAccount(accountId);
    fetchWithdrawals(accountId);
    setShowWithdrawalsModal(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleCopyChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCopyFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditFormData((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
          : name === "balance" && value === ""
          ? ""
          : value,
    }));
  };

  const handleCloseCombinedPnL = () => {
    setShowCombinedPnLModal(false);
    setCombinedPnLAccountIds([]);
  };

  const handleSymbolChange = (symbol) => {
    setFormData((prev) => {
      const newSymbols = prev.symbols.includes(symbol)
        ? prev.symbols.filter((s) => s !== symbol)
        : [...prev.symbols, symbol];
      return { ...prev, symbols: newSymbols };
    });
  };

  const handleCopySymbolChange = (symbol) => {
    setCopyFormData((prev) => {
      const newSymbols = prev.symbols.includes(symbol)
        ? prev.symbols.filter((s) => s !== symbol)
        : [...prev.symbols, symbol];
      return { ...prev, symbols: newSymbols };
    });
  };

  const handleEditSymbolChange = (symbol) => {
    setEditFormData((prev) => {
      const newSymbols = prev.symbols.includes(symbol)
        ? prev.symbols.filter((s) => s !== symbol)
        : [...prev.symbols, symbol];
      return { ...prev, symbols: newSymbols };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.symbols.length === 0) {
      toast.error("At least one symbol must be selected");
      return;
    }
    try {
      const payload = {
        ...formData,
        symbols: formData.symbols,
        show_balance: formData.show_balance,
        send_telegram_notifications: formData.send_telegram_notifications,
      };
      const response = await axios.post(`${API_URL_SERVER}/accounts`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      toast.success(response.data.message);
      setFormData({
        mt5AccountId: "",
        password: "",
        mt5Server: "",
        nickName: "",
        strategy: "Main to Copy",
        lot_size: "1.0",
        trailing_sl_offset: "10",
        symbols: ["BTCUSD"],
        show_balance: false,
        send_telegram_notifications: false,
      });
      fetchAccounts();
      setShowForm(false);
    } catch (error) {
      toast.error(error.response?.data?.error || "Something went wrong");
    }
  };

  const handleCopySubmit = async (e) => {
    e.preventDefault();
    if (copyFormData.symbols.length === 0) {
      toast.error("At least one symbol must be selected");
      return;
    }
    try {
      const payload = {
        ...copyFormData,
        symbols: copyFormData.symbols,
        sourceAccountId: copySourceAccount,
        show_balance: copyFormData.show_balance,
        send_telegram_notifications: copyFormData.send_telegram_notifications,
      };
      const response = await axios.post(
        `${API_URL_SERVER}/copy_accounts`,
        payload,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      toast.success(response.data.message);
      setCopyFormData({
        mt5AccountId: "",
        password: "",
        mt5Server: "",
        nickName: "",
        strategy: "Main to Copy",
        lot_size: "1.0",
        trailing_sl_offset: "10",
        symbols: ["BTCUSD"],
        sourceAccountId: "",
        show_balance: false,
        send_telegram_notifications: false,
      });
      setShowCopyForm(false);
      fetchAccounts();
    } catch (error) {
      toast.error(error.response?.data?.error || "Failed to add copy account");
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (editFormData.symbols.length === 0) {
      toast.error("At least one symbol must be selected");
      return;
    }
    try {
      const payload = {
        ...editFormData,
        symbols: editFormData.symbols,
        show_balance: editFormData.show_balance,
        send_telegram_notifications: editFormData.send_telegram_notifications,
      };
      const response = await axios.put(
        `${API_URL_SERVER}/accounts/${editFormData.mt5AccountId}?originalStrategy=${editFormData.originalStrategy}`,
        payload,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      toast.success(response.data.message);
      setShowEditModal(false);
      fetchAccounts();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update account");
    }
  };

  const handleStartStop = async (accountId, strategy, isRunning) => {
    try {
      const endpoint = isRunning ? "/stop" : "/start";
      const response = await axios.post(
        `${API_URL_SERVER}${endpoint}`,
        { account_id: accountId, strategy },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      toast.success(response.data.message);
      await fetchStatus();
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          `Failed to ${isRunning ? "stop" : "start"}`
      );
      setStatus({ trading_active: false, accounts: [] });
      await fetchStatus();
    }
  };

  const handleStopAll = async () => {
    try {
      const response = await axios.post(
        `${API_URL_SERVER}/stop`,
        {},
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      toast.success(response.data.message);
      await fetchStatus();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to stop all trading"
      );
      setStatus({ trading_active: false, accounts: [] });
      await fetchStatus();
    }
  };

  const handleStartAll = async () => {
    if (window.confirm("Are you sure you want to START ALL accounts?")) {
      try {
        const response = await axios.post(
          `${API_URL_SERVER}/start`,
          {}, // Empty body signals the backend to start all
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );
        toast.success(response.data.message);
        await fetchStatus();
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to start all accounts"
        );
        // Even if it fails, try to fetch status to see if partial success occurred
        await fetchStatus();
      }
    }
  };

  const handleEdit = (account) => {
    setEditFormData({
      mt5AccountId: account.mt5AccountId,
      password: account.password,
      mt5Server: account.mt5Server,
      nickName: account.nickName,
      lot_size: account.lot_size.toString(),
      max_profit: account.max_profit ? account.max_profit.toString() : "0",
      max_loss: account.max_loss ? account.max_loss.toString() : "0",
      trailing_sl_offset: account.trailing_sl_offset.toString(),
      strategy: account.strategy || "Main to Copy",
      symbols: account.symbols || (account.symbol ? [account.symbol] : ["BTCUSD"]),
      originalStrategy: account.strategy,
      show_balance: account.show_balance || false,
      send_telegram_notifications: account.send_telegram_notifications || false,
      lot_size_last_updated: account.lot_size_last_updated,
      max_profit_last_updated: account.max_profit_last_updated,
      max_loss_last_updated: account.max_loss_last_updated,
    });
    setShowEditModal(true);
  };

  const isLotSizeLocked = (lastUpdatedIso) => {
    if (!lastUpdatedIso) return false;
    const now = new Date();
    const currentIST = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    const lastUpdatedIST = new Date(new Date(lastUpdatedIso).toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    
    const unlockTime = new Date(lastUpdatedIST);
    unlockTime.setDate(unlockTime.getDate() + 1);
    unlockTime.setHours(0, 0, 0, 0);
    
    return currentIST.getTime() < unlockTime.getTime();
  };

  const isMaxProfitLocked = (lastUpdatedIso) => {
    if (!lastUpdatedIso) return false;
    const now = new Date();
    const currentIST = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    const lastUpdatedIST = new Date(new Date(lastUpdatedIso).toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    
    const unlockTime = new Date(lastUpdatedIST);
    unlockTime.setDate(unlockTime.getDate() + 1);
    unlockTime.setHours(0, 0, 0, 0);
    
    return currentIST.getTime() < unlockTime.getTime();
  };

  const isMaxLossLocked = (lastUpdatedIso) => {
    if (!lastUpdatedIso) return false;
    const now = new Date();
    const currentIST = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    const lastUpdatedIST = new Date(new Date(lastUpdatedIso).toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    
    const unlockTime = new Date(lastUpdatedIST);
    unlockTime.setDate(unlockTime.getDate() + 1);
    unlockTime.setHours(0, 0, 0, 0);
    
    return currentIST.getTime() < unlockTime.getTime();
  };

  const isStopLocked = (lastStartedIso) => {
    return false;
  };

  const handleDelete = async (accountId, strategy) => {
    if (
      window.confirm(
        `Are you sure you want to delete account ${accountId} with strategy ${strategy}?`
      )
    ) {
      try {
        const response = await axios.delete(
          `${API_URL_SERVER}/accounts/${accountId}?strategy=${strategy}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        toast.success(response.data.message);
        fetchAccounts();
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to delete account"
        );
      }
    }
  };

  const handleExit = async (accountId, strategy) => {
    if (
      window.confirm(
        `Are you sure you want to exit positions for account ${accountId} and its copy accounts?`
      )
    ) {
      try {
        const response = await axios.post(
          `${API_URL_SERVER}/exit`,
          { account_id: accountId, strategy },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        toast.success(response.data.message);
        fetchStatus();
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to exit positions"
        );
      }
    }
  };

  const handleShowPnL = (accountId) => {
    console.log("handleShowPnL called with accountId:", accountId);
    const account = accounts.find((acc) => acc.mt5AccountId === accountId);
    setSelectedAccount(account); // Store the full account object
    setShowPnLModal(true);
  };

  const handleShowCombinedPnL = () => {
    const uniqueAccountIds = [
      ...new Set(accounts.map((acc) => acc.mt5AccountId)),
    ];
    if (uniqueAccountIds.length === 0) {
      toast.error("No accounts available to display combined PnL");
      return;
    }
    setCombinedPnLAccountIds(uniqueAccountIds);
    setShowCombinedPnLModal(true);
  };
  
  // --- NEW HANDLER FOR BULK LOT UPDATE ---
  const handleAutoUpdateLots = async () => {
    if (!lotDivisor1 || parseFloat(lotDivisor1) <= 0 || !lotDivisor2 || parseFloat(lotDivisor2) <= 0) {
      toast.error("Please enter valid divisor amounts (e.g., 256 for both)");
      return;
    }
    
    setIsUpdatingLots(true);
    try {
      const response = await axios.post(
        `${API_URL_SERVER}/auto_update_lots`,
        { divisor1: parseFloat(lotDivisor1), divisor2: parseFloat(lotDivisor2) },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      toast.success(response.data.message);
      if (response.data.details) {
          console.log(response.data.details);
      }
      setShowLotUpdateModal(false);
      fetchAccounts(); 
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to auto update lots");
    } finally {
      setIsUpdatingLots(false);
    }
  };

  const handleAlert = (accountId, strategy) => {
    navigate(`/alert/${accountId}/${strategy}`);
  };

  const handleCopyTrade = (account) => {
    setCopySourceAccount(account.mt5AccountId);
    setCopyFormData({
      ...copyFormData,
      sourceAccountId: account.mt5AccountId,
      strategy: account.strategy || "Main to Copy",
      symbols:
        account.symbols || (account.symbol ? [account.symbol] : ["BTCUSD"]),
      show_balance: account.show_balance || false,
      send_telegram_notifications: account.send_telegram_notifications || false,
    });
    setShowCopyForm(true);
  };

  const handleTrade = (accountId, strategy) => {
    navigate(`/trade/${accountId}/${strategy}`);
  };

  return (
    <div className="mt-5">
      <div className="me-3">
        <h1 className="text-center">All Accounts</h1>
        {user.role === "admin" && (
          <div className="d-flex justify-content-end mb-4 flex-wrap">
            <button
              className="btn btn-primary m-2"
              onClick={() => setShowForm(!showForm)}
            >
              {showForm ? "Close Form" : "Add Account"}
            </button>
            <button
              className="btn btn-success m-2"
              onClick={handleStartAll}
            >
              Start All Accounts
            </button>
            <button
              className="btn btn-danger m-2"
              onClick={handleStopAll}
              disabled={!status.trading_active}
            >
              Stop All Accounts
            </button>
            <button
              className="btn btn-info m-2"
              onClick={handleShowCombinedPnL}
            >
              View All PnL
            </button>
            <button
              className="btn btn-warning m-2"
              onClick={() => setShowLotUpdateModal(true)}
            >
              Auto Update Lots
            </button>
          </div>
        )}
      </div>

      {showTradeDashboardModal && selectedAccountDetails && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="trade_dashboard modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Live Trades for Account {selectedAccountDetails.accountId} (
                  {selectedAccountDetails.strategy})
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowTradeDashboardModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <TradeDashboard
                  accountId={selectedAccountDetails.accountId}
                  strategy={selectedAccountDetails.strategy}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      
      {showLotUpdateModal && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Calculate Lot Sizes</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowLotUpdateModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="lotDivisor1" className="form-label">
                    Divisor 1
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    id="lotDivisor1"
                    value={lotDivisor1}
                    onChange={(e) => setLotDivisor1(e.target.value)}
                    placeholder="256"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="lotDivisor2" className="form-label">
                    Divisor 2
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    id="lotDivisor2"
                    value={lotDivisor2}
                    onChange={(e) => setLotDivisor2(e.target.value)}
                    placeholder="256"
                  />
                </div>
                {isUpdatingLots ? (
                   <div className="text-center">
                     <div className="spinner-border text-primary" role="status">
                       <span className="visually-hidden">Loading...</span>
                     </div>
                     <p>Connecting to accounts and calculating... please wait.</p>
                   </div>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleAutoUpdateLots}
                  >
                    Calculate & Update All
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showForm && user.role === "admin" && (
        <div className="row justify-content-center mb-5">
          <div className="col-md-6">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="strategy" className="form-label">
                  Select Strategy
                </label>
                <select
                  className="form-control"
                  id="strategy"
                  name="strategy"
                  value={formData.strategy}
                  onChange={handleChange}
                  required
                >
                  {strategies.map(strategy => (
                      <option key={strategy} value={strategy}>{strategy}</option>
                    ))}
                </select>
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Symbols</label>
                <div className="border p-2 rounded bg-white">
                  {VALID_SYMBOLS.map((symbol) => (
                    <div key={symbol} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`symbol-${symbol}`}
                        checked={formData.symbols.includes(symbol)}
                        onChange={() => handleSymbolChange(symbol)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`symbol-${symbol}`}
                      >
                        {symbol}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="mt5Server" className="form-label">
                  MT5 Server
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="mt5Server"
                  name="mt5Server"
                  value={formData.mt5Server}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="mt5AccountId" className="form-label">
                  MT5 Account ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="mt5AccountId"
                  name="mt5AccountId"
                  value={formData.mt5AccountId}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="nickName" className="form-label">
                  Nickname
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="nickName"
                  name="nickName"
                  value={formData.nickName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="lot_size" className="form-label">
                  Lot Size
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lot_size"
                  name="lot_size"
                  value={formData.lot_size}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="max_profit" className="form-label">
                  Max Profit ($)
                </label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="max_profit"
                  name="max_profit"
                  value={formData.max_profit} // Use editFormData.max_profit or copyFormData.max_profit accordingly
                  onChange={handleChange}     // Use handleEditChange or handleCopyChange accordingly
                  placeholder="0 to disable"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="max_loss" className="form-label">
                  Max Loss ($)
                </label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="max_loss"
                  name="max_loss"
                  value={formData.max_loss} // CHANGE THIS TO copyFormData.max_loss FOR THE COPY FORM
                  onChange={handleChange}     // CHANGE THIS TO handleCopyChange FOR THE COPY FORM
                  placeholder="0 to disable"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="trailing_sl_offset" className="form-label">
                  Trailing SL Offset
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="trailing_sl_offset"
                  name="trailing_sl_offset"
                  value={formData.trailing_sl_offset}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="show_balance"
                  name="show_balance"
                  checked={formData.show_balance}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="show_balance">
                  Show Balance
                </label>
              </div>
              <div className="mb-3 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="send_telegram_notifications"
                  name="send_telegram_notifications"
                  checked={formData.send_telegram_notifications}
                  onChange={handleChange}
                />
                <label
                  className="form-check-label"
                  htmlFor="send_telegram_notifications"
                >
                  Send Telegram Notifications
                </label>
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="width row mt-5">
        <div className="col-12">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Login ID</th>
                  <th>Nickname</th>

                  {(() => {
                    const fullAccessIds = (user?.fullAccessAccountIds || []).map(String);
                    const hasAnyFullAccess = fullAccessIds.length > 0;
                    return (
                      <>
                        {(user.role === "admin" || user.show_lot_size || hasAnyFullAccess) && <th>Lot Size</th>}
                        {(user.role === "admin" || hasAnyFullAccess) && <th>Max Profit</th>}
                        {(user.role === "admin" || hasAnyFullAccess ) && <th>Max Loss</th>}

                        {(user.role === "admin" || hasAnyFullAccess) && (
                            <>
                                <th>Strategy</th>
                                <th>Symbols</th>
                                <th>Trailing SL</th>
                                <th>Alerts</th>
                            </>
                        )}

                        {(user.role === "admin" || user.manual_trade || hasAnyFullAccess) && <th>Trade</th>}
                        {(user.role === "admin" || user.can_start_stop === true || hasAnyFullAccess) && <th>Trading</th>}
                        {(user.role === "admin" || user.can_edit_lot || hasAnyFullAccess) && <th>Edit</th>}

                        {(user.role === "admin" || hasAnyFullAccess) && (
                            <>
                                <th>Delete</th>
                                <th>Exit Trade</th>
                                <th>Copy Trade</th>
                                <th>Source</th>
                            </>
                        )}
                      </>
                    );
                  })()}
                  {(() => {
                  const fullAccessIds = (user?.fullAccessAccountIds || []).map(String);
                  const hasAnyFullAccess = fullAccessIds.length > 0;
                  return (
                    <>
                      <th>View PnL</th>
                      {(user.role === "admin" || hasAnyFullAccess) && <th>W</th>}
                    </>
                  );
                  })()}
                </tr>
              </thead>
              <tbody>
                {accounts.map((account, index) => {
                  const accountStatus =
                    status.accounts?.[
                      `${account.mt5AccountId}:${account.strategy}`
                    ] || {};
                  const isRunning = accountStatus.is_running || false;
                  
                  const fullAccessIds = (user?.fullAccessAccountIds || []).map(String);
                  const hasAnyFullAccess = fullAccessIds.length > 0;
                  
                  // Cascade full access rights if the account is a child of a fully accessed source
                  const isFullAccess = fullAccessIds.includes(String(account.mt5AccountId)) || 
                                       (account.is_copy_account && fullAccessIds.includes(String(account.sourceAccountId)));

                  return (
                    <tr key={`${account.mt5AccountId}:${account.strategy}`}>
                      <td>{index + 1}</td>
                      <td>{account.mt5AccountId}</td>
                      <td>{account.nickName}</td>

                      {(user.role === "admin" || user.show_lot_size || hasAnyFullAccess) && (
                          <td>{ (user.role === "admin" || user.show_lot_size || isFullAccess) ? account.lot_size : "-" }</td>
                      )}
                      {(user.role === "admin" || hasAnyFullAccess) && (
                          <td>{ (user.role === "admin" || isFullAccess) ? `$${account.max_profit || 0}` : "-" }</td>
                      )}
                      {(user.role === "admin" || hasAnyFullAccess) && (
                          <td>{ (user.role === "admin" || isFullAccess) ? `$${account.max_loss || 0}` : "-" }</td>
                      )}
                      {(user.role === "admin" || hasAnyFullAccess) && (
                        <>
                          <td>{ (user.role === "admin" || isFullAccess) ? account.strategy : "-" }</td>
                          <td>
                            {(user.role === "admin" || isFullAccess) ? (
                              account.symbols ||
                              (account.symbol ? [account.symbol] : ["BTCUSD"])
                            ).join(", ") : "-"}
                          </td>
                          <td>{ (user.role === "admin" || isFullAccess) ? account.trailing_sl_offset : "-" }</td>
                          <td>
                            {(user.role === "admin" || isFullAccess) ? (
                                <button
                                  className="btn btn-info"
                                  onClick={() =>
                                    handleAlert(
                                      account.mt5AccountId,
                                      account.strategy
                                    )
                                  }
                                >
                                  Alerts
                                </button>
                            ) : "-"}
                          </td>
                        </>
                      )}
                      
                      {(user.role === "admin" || user.manual_trade || hasAnyFullAccess) && (
                          <td>
                            {(user.role === "admin" || user.manual_trade || isFullAccess) ? (
                                <button
                                  className="btn btn-primary"
                                  onClick={() => handleTrade(account.mt5AccountId, account.strategy)}
                                >
                                  Trade
                                </button>
                            ) : "-"}
                          </td>
                      )}
                      
                      {(user.role === "admin" || user.can_start_stop === true || hasAnyFullAccess) && (
                          <td>
                            {(user.role === "admin" || user.can_start_stop === true || isFullAccess) ? (
                               <button
                                  className={`btn ${isRunning ? "btn-danger" : "btn-success"}`}
                                  onClick={() => handleStartStop(account.mt5AccountId, account.strategy, isRunning)}
                            >
                            {isRunning ? "Stop" : "Start"}
                            </button>
                            ) : "-"}
                          </td>
                      )}

                      {(user.role === "admin" || user.can_edit_lot || hasAnyFullAccess) && (
                        <td>
                          {(user.role === "admin" || user.can_edit_lot || isFullAccess) ? (
                              <button
                                className="btn btn-warning"
                                onClick={() => handleEdit(account)}
                              >
                                Edit
                              </button>
                          ) : "-"}
                        </td>
                      )}

                      {(user.role === "admin" || hasAnyFullAccess) && (
                        <>
                          <td>
                            {(user.role === "admin" || isFullAccess) ? (
                                <button
                                  className="btn btn-danger"
                                  onClick={() =>
                                    handleDelete(
                                      account.mt5AccountId,
                                      account.strategy
                                    )
                                  }
                                >
                                  Delete
                                </button>
                            ) : "-"}
                          </td>
                          <td>
                            {(user.role === "admin" || isFullAccess) ? (
                                <button
                                  className="btn btn-danger"
                                  onClick={() =>
                                    handleExit(
                                      account.mt5AccountId,
                                      account.strategy
                                    )
                                  }
                                >
                                  Exit
                                </button>
                            ) : "-"}
                          </td>
                          <td>
                            {(user.role === "admin" || isFullAccess) ? (
                                <button
                                  className="btn btn-primary"
                                  onClick={() => handleCopyTrade(account)}
                                >
                                  Add Account
                                </button>
                            ) : "-"}
                          </td>
                          <td>
                            {(user.role === "admin" || isFullAccess) ? (account.is_copy_account
                              ? account.sourceAccountId
                              : "-") : "-"}
                          </td>
                        </>
                      )}
                      <td>
                        <button
                          className="btn btn-info"
                          onClick={() => 
                            handleShowPnL(account.mt5AccountId, account.strategy)}
                        >
                          View
                        </button>
                      </td>
                      {(user.role === "admin" || isFullAccess) && (
                        <td>
                          <button
                            className="btn btn-secondary btn-w"
                            onClick={() =>
                              handleShowWithdrawals(account.mt5AccountId)
                            }
                          >
                            W
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showEditModal && (user.role === "admin" || user.can_edit_lot || user?.fullAccessAccountIds?.includes(String(editFormData?.mt5AccountId))) && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Edit Account {editFormData?.mt5AccountId}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleEditSubmit}>
                  {user.role === "admin" || user?.fullAccessAccountIds?.includes(String(editFormData?.mt5AccountId)) ? (
                    /* ================= ADMIN VIEW (FULL ACCESS) ================= */
                    <>
                      <div className="mb-3">
                        <label htmlFor="editStrategy" className="form-label">
                          Select Strategy
                        </label>
                        <select
                          className="form-control"
                          id="editStrategy"
                          name="strategy"
                          value={editFormData?.strategy}
                          onChange={handleEditChange}
                          required
                        >
                            {strategies.map(strategy => (
                      <option key={strategy} value={strategy}>{strategy}</option>
                    ))}
                          </select>
                      </div>
                      <div className="form-group mb-3">
                        <label className="form-label">Symbols</label>
                        <div className="border p-2 rounded bg-white">
                          {VALID_SYMBOLS.map((symbol) => (
                            <div key={symbol} className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`edit-symbol-${symbol}`}
                                checked={editFormData?.symbols.includes(symbol)}
                                onChange={() => handleEditSymbolChange(symbol)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`edit-symbol-${symbol}`}
                              >
                                {symbol}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="editMt5Server" className="form-label">
                          Server
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="editMt5Server"
                          name="mt5Server"
                          value={editFormData?.mt5Server}
                          onChange={handleEditChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="editMt5AccountId"
                          className="form-label"
                        >
                          MT5 Login ID
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="editMt5AccountId"
                          name="mt5AccountId"
                          value={editFormData?.mt5AccountId}
                          onChange={handleEditChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="editPassword" className="form-label">
                          Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="editPassword"
                          name="password"
                          value={editFormData?.password}
                          onChange={handleEditChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="editNickName" className="form-label">
                          Nickname
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="editNickName"
                          name="nickName"
                          value={editFormData?.nickName}
                          onChange={handleEditChange}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="editLotSize" className="form-label">
                          Lot Size
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="editLotSize"
                          name="lot_size"
                          value={editFormData?.lot_size}
                          onChange={handleEditChange}
                          required
                          disabled={isLotSizeLocked(editFormData?.lot_size_last_updated)}
                        />
                        {isLotSizeLocked(editFormData?.lot_size_last_updated) && (
                          <small className="text-danger">Locked until 00:00 IST.</small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label htmlFor="max_profit" className="form-label">
                          Max Profit ($)
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="max_profit"
                          name="max_profit"
                          value={editFormData.max_profit}
                          onChange={handleEditChange}
                          placeholder="0 to disable"
                          disabled={isMaxProfitLocked(editFormData?.max_profit_last_updated)}
                        />
                        {isMaxProfitLocked(editFormData?.max_profit_last_updated) && (
                          <small className="text-danger">Locked until 00:00 IST.</small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label htmlFor="max_loss" className="form-label">
                          Max Loss ($)
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="max_loss"
                          name="max_loss"
                          value={editFormData.max_loss}
                          onChange={handleEditChange}
                          placeholder="0 to disable"
                          disabled={isMaxLossLocked(editFormData?.max_loss_last_updated)}
                        />
                        {isMaxLossLocked(editFormData?.max_loss_last_updated) && (
                          <small className="text-danger">Locked until 00:00 IST.</small>
                        )}
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="editTrailingSlOffset"
                          className="form-label"
                        >
                          Trailing SL Offset
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="editTrailingSlOffset"
                          name="trailing_sl_offset"
                          value={editFormData?.trailing_sl_offset}
                          onChange={handleEditChange}
                          required
                        />
                      </div>
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="editShowBalance"
                          name="show_balance"
                          checked={editFormData?.show_balance}
                          onChange={handleEditChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="editShowBalance"
                        >
                          Show Balance
                        </label>
                      </div>
                      <div className="mb-3 form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="editSendTelegramNotifications"
                          name="send_telegram_notifications"
                          checked={editFormData?.send_telegram_notifications}
                          onChange={handleEditChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="editSendTelegramNotifications"
                        >
                          Send Telegram Notifications
                        </label>
                      </div>
                    </>
                  ) : (
                    /* ================= USER VIEW (RESTRICTED ACCESS) ================= */
                    <>
                      <div className="mb-3">
                        <label className="form-label">Account</label>
                        <input
                          type="text"
                          className="form-control"
                          value={`${editFormData?.mt5AccountId} - ${editFormData?.nickName}`}
                          disabled
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="editLotSize" className="form-label">
                          Lot Size
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          className="form-control"
                          id="editLotSize"
                          name="lot_size"
                          value={editFormData?.lot_size}
                          onChange={handleEditChange}
                          requireddisabled={isLotSizeLocked(editFormData?.lot_size_last_updated)}
                        />
                        {isLotSizeLocked(editFormData?.lot_size_last_updated) && (
                          <small className="text-danger">Locked until 00:00 IST.</small>
                        )}
                      </div>
                    </>
                  )}

                  <button type="submit" className="btn btn-primary">
                    Save Changes
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPnLModal && selectedAccount && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {user.role === "user"
                    ? selectedAccount.mt5AccountId
                    : `${selectedAccount.mt5AccountId} - ${selectedAccount.nickName} - ${selectedAccount.strategy}`}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPnLModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <PnLCalendar
                  accountId={selectedAccount.mt5AccountId}
                  strategy={selectedAccount.strategy}
                  userRole={user.role}
                  showTrades={user.trades || user?.fullAccessAccountIds?.includes(selectedAccount.mt5AccountId)}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {showCombinedPnLModal && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Combined PnL for {combinedPnLAccountIds.length} Accounts
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseCombinedPnL}
                ></button>
              </div>
              <div className="modal-body">
                <PnLCalendar
                  accountId={combinedPnLAccountIds}
                  combined={true}
                  userRole={user.role}
                  strategy="Combined"
                  showTrades={user.trades || user?.fullAccessAccountIds?.length > 0}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {showCopyForm && (user.role === "admin" || (user?.fullAccessAccountIds || []).map(String).includes(String(copySourceAccount))) && (
        <div className="row justify-content-center mb-5">
          <div className="col-md-6">
            <h3>Add Copy Account for {copySourceAccount}</h3>
            <form onSubmit={handleCopySubmit}>
              {/* ... Existing Copy Form Content ... */}
               <div className="mb-3">
                <label htmlFor="strategy" className="form-label">
                  Select Strategy
                </label>
                <select
                  className="form-control"
                  id="strategy"
                  name="strategy"
                  value={copyFormData.strategy}
                  onChange={handleCopyChange}
                  required
                >
                  {strategies.map(strategy => (
                      <option key={strategy} value={strategy}>{strategy}</option>
                    ))}
                </select>
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Symbols</label>
                <div className="border p-2 rounded bg-white">
                  {VALID_SYMBOLS.map((symbol) => (
                    <div key={symbol} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`copy-symbol-${symbol}`}
                        checked={copyFormData.symbols.includes(symbol)}
                        onChange={() => handleCopySymbolChange(symbol)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`copy-symbol-${symbol}`}
                      >
                        {symbol}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="mt5Server" className="form-label">
                  Server
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="mt5Server"
                  name="mt5Server"
                  value={copyFormData.mt5Server}
                  onChange={handleCopyChange}
                  placeholder="Enter Server"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="mt5AccountId" className="form-label">
                  MT5 Login ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="mt5AccountId"
                  name="mt5AccountId"
                  value={copyFormData.mt5AccountId}
                  onChange={handleCopyChange}
                  placeholder="Enter MT5 Login ID"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  value={copyFormData.password}
                  onChange={handleCopyChange}
                  placeholder="Enter Password"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="nickName" className="form-label">
                  Nickname
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="nickName"
                  name="nickName"
                  value={copyFormData.nickName}
                  onChange={handleCopyChange}
                  placeholder="Enter Your Nickname"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="lot_size" className="form-label">
                  Lot Size
                </label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="lot_size"
                  name="lot_size"
                  value={copyFormData.lot_size}
                  onChange={handleCopyChange}
                  placeholder="Enter Lot Size"
                  required
                />
              </div>
              <div className="mb-3">
                <label htmlFor="max_profit" className="form-label">
                  Max Profit ($)
                </label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="max_profit"
                  name="max_profit"
                  value={copyFormData.max_profit}
                  onChange={handleCopyChange}
                  placeholder="0 to disable"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="max_loss" className="form-label">
                  Max Loss ($)
                </label>
                <input
                  type="number"
                  step="0.01"
                  className="form-control"
                  id="max_loss"
                  name="max_loss"
                  value={copyFormData.max_loss} // CHANGE THIS TO copyFormData.max_loss FOR THE COPY FORM
                  onChange={handleCopyChange}     // CHANGE THIS TO handleCopyChange FOR THE COPY FORM
                  placeholder="0 to disable"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="trailing_sl_offset" className="form-label">
                  Trailing SL Offset
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="trailing_sl_offset"
                  name="trailing_sl_offset"
                  value={copyFormData.trailing_sl_offset}
                  onChange={handleCopyChange}
                  placeholder="Enter Trailing SL Offset"
                  required
                />
              </div>
              <div className="mb-3 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="copyShowBalance"
                  name="show_balance"
                  checked={copyFormData.show_balance}
                  onChange={handleCopyChange}
                />
                <label className="form-check-label" htmlFor="copyShowBalance">
                  Show Balance
                </label>
              </div>
              <div className="mb-3 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="copySendTelegramNotifications"
                  name="send_telegram_notifications"
                  checked={copyFormData.send_telegram_notifications}
                  onChange={handleCopyChange}
                />
                <label
                  className="form-check-label"
                  htmlFor="copySendTelegramNotifications"
                >
                  Send Telegram Notifications
                </label>
              </div>
              <div className="d-grid gap-2">
                <button type="submit" className="btn btn-primary">
                  Add Copy Account
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowCopyForm(false);
                    setCopySourceAccount(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showWithdrawalsModal && (user.role === "admin" || user?.fullAccessAccountIds?.includes(selectedWithdrawalAccount)) && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Manage Withdrawals for {selectedWithdrawalAccount}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowWithdrawalsModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="withdrawalAmount" className="form-label">
                    Amount ($)
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="withdrawalAmount"
                    value={withdrawalAmount}
                    onChange={(e) => setWithdrawalAmount(e.target.value)}
                    placeholder="Enter amount"
                    min="0"
                    step="0.01"
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="withdrawalDate" className="form-label">
                    Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="withdrawalDate"
                    value={withdrawalDate}
                    onChange={(e) => setWithdrawalDate(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="withdrawalNotes" className="form-label">
                    Notes (Optional)
                  </label>
                  <textarea
                    className="form-control"
                    id="withdrawalNotes"
                    value={withdrawalNotes}
                    onChange={(e) => setWithdrawalNotes(e.target.value)}
                    placeholder="Enter notes"
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAddWithdrawal}
                >
                  Add Withdrawal
                </button>
                <button
                  type="button"
                  className="btn btn-info ms-2"
                  onClick={() => {
                    setShowWithdrawalsViewModal(true);
                    fetchWithdrawals(selectedWithdrawalAccount);
                  }}
                >
                  View Withdrawals
                </button>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowWithdrawalsModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showWithdrawalsViewModal && (user.role === "admin" || user?.fullAccessAccountIds?.includes(selectedWithdrawalAccount)) && (
        <div
          className="modal"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Withdrawals for {selectedWithdrawalAccount}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowWithdrawalsViewModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="total-withdrawn mb-3">
                  <strong>Total Withdrawn: </strong>
                  <span className="negative-amount">
                    $
                    {totalWithdrawn.toLocaleString("en-US", {
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
                {withdrawals.length > 0 ? (
                  <div className="withdrawal-list">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Amount ($)</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {withdrawals.map((withdrawal) => (
                          <tr key={withdrawal.id}>
                            <td>{withdrawal.date}</td>
                            <td>
                              <span className="negative-amount">
                                {withdrawal.amount.toLocaleString("en-US", {
                                  maximumFractionDigits: 2,
                                })}
                              </span>
                            </td>
                            <td>{withdrawal.notes || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>No withdrawals recorded.</p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowWithdrawalsViewModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountsPage;